<div class="scad-tab-log">
  <div class="scad-tab-log__wrapper">
    <div class="scad-tab-log__left-sec">
      <div class="scad-title__semi-bold mb-3">Outcome</div>
      <div class="scad-tab-log__header">
        <div class="d-flex scad-tab-log__tabs">
          <div
            class="scad-tab-log__item"
            [ngClass]="{ active: typeOfIncome === 'Results' }"
            (click)="typeOfIncome = 'Results'"
          >
            Results
          </div>
          <div
            class="scad-tab-log__item"
            [ngClass]="{ active: typeOfIncome === 'Comparision' }"
            (click)="typeOfIncome = 'Comparision'"
          >
            Comparision
          </div>
        </div>
      </div>
      <div *ngIf="typeOfIncome === 'Results'" class="scad-tab-log__body">
        <ul *ngIf="autoMlService.resultPreviewData.length >0" class="tabs-new">
          <li
            [ngClass]="{ active: selectedTableIndex === i }"
            (click)="selectedTableIndex = i"
            *ngFor="let item of autoMlService.resultPreviewData; let i = index"
          >
            {{ item.name }}
          </li>
        </ul>
        <div *ngIf="autoMlService.resultPreviewData.length >0;else nodata" class="scad-tab-log__table">
          <div class="table-wrapper">
            <table>
              <tbody>
                <tr>
                  <th *ngFor="let item of getTableKey()">{{ item }}</th>
                </tr>
                <tr *ngFor="let item of getTableData(); let i = index">
                  <td *ngFor="let key of getTableKey()">
                    <div class="data-cell">
                      <svg
                        *ngIf="item[key] === 'Success'"
                        xmlns="http://www.w3.org/2000/svg"
                        width="23"
                        height="23"
                        viewBox="0 0 23 23"
                        fill="none"
                      >
                        <path
                          d="M11.1752 19.2837C15.6534 19.2837 19.2837 15.6534 19.2837 11.1752C19.2837 6.69696 15.6534 3.06665 11.1752 3.06665C6.69696 3.06665 3.06665 6.69696 3.06665 11.1752C3.06665 15.6534 6.69696 19.2837 11.1752 19.2837Z"
                          fill="#659B5C"
                        />
                        <path
                          d="M6.89331 11.141L9.96818 14.2159L15.4574 8.13452"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      <svg
                        *ngIf="item[key] === 'Error'"
                        xmlns="http://www.w3.org/2000/svg"
                        width="23"
                        height="23"
                        viewBox="0 0 23 23"
                        fill="none"
                      >
                        <path
                          d="M20.125 11.5C20.125 6.73828 16.2617 2.875 11.5 2.875C6.73828 2.875 2.875 6.73828 2.875 11.5C2.875 16.2617 6.73828 20.125 11.5 20.125C16.2617 20.125 20.125 16.2617 20.125 11.5Z"
                          fill="#E65E6E"
                        />
                        <path
                          d="M11.2422 7.4593L11.5001 12.9375L11.7575 7.4593C11.7591 7.42428 11.7535 7.3893 11.7411 7.35651C11.7287 7.32371 11.7098 7.29378 11.6854 7.26856C11.6611 7.24333 11.6318 7.22333 11.5995 7.20979C11.5672 7.19624 11.5324 7.18943 11.4974 7.18977V7.18977C11.4627 7.1901 11.4285 7.1974 11.3968 7.21124C11.365 7.22509 11.3364 7.24519 11.3125 7.27034C11.2887 7.2955 11.2702 7.3252 11.2581 7.35766C11.2461 7.39013 11.2406 7.4247 11.2422 7.4593V7.4593Z"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M11.5 16.5272C11.3223 16.5272 11.1486 16.4745 11.0009 16.3758C10.8531 16.2771 10.738 16.1368 10.67 15.9726C10.602 15.8084 10.5842 15.6278 10.6188 15.4535C10.6535 15.2792 10.7391 15.1191 10.8647 14.9935C10.9904 14.8678 11.1504 14.7823 11.3247 14.7476C11.499 14.7129 11.6796 14.7307 11.8438 14.7987C12.008 14.8667 12.1483 14.9819 12.247 15.1296C12.3457 15.2774 12.3984 15.4511 12.3984 15.6288C12.3984 15.8671 12.3038 16.0956 12.1353 16.2641C11.9668 16.4326 11.7383 16.5272 11.5 16.5272Z"
                          fill="white"
                        />
                      </svg>
                      {{ item[key] }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- <div class="pagination">
              <div class="row-count">
                <p>Row per page</p>
                <ng-select
                  [items]="pageArr"
                  [searchable]="false"
                  [clearable]="false"
                  [(ngModel)]="selectedPage"
                ></ng-select>
                <p>{{ "of " + _fb.previewData.length + " rows" }}</p>
              </div>
              <div class="row-pagination">
                <svg
                  (click)="decriement()"
                  class="left"
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                >
                  <circle
                    cx="16"
                    cy="16"
                    r="16"
                    transform="matrix(-1 0 0 1 32 0)"
                    fill="#1847DF"
                  />
                  <path
                    d="M13 12.5L18 16.45L13 20.3571"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <div class="number">{{ page }}</div>
                <p>{{ "out of " + testData.length }}</p>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  (click)="incriement()"
                >
                  <circle
                    cx="16"
                    cy="16"
                    r="16"
                    transform="matrix(-1 0 0 1 32 0)"
                    fill="#1847DF"
                  />
                  <path
                    d="M13 12.5L18 16.45L13 20.3571"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div> -->
        </div>
        
      </div>
      <div *ngIf="typeOfIncome === 'Comparision'">
        <div class="scd-ml-comparision__inner">
          <div class="scd-ml-comparision__accordian" [ngClass]="{'active': !autoMlService.isRank}">
            <div class="scd-ml-comparision__accordian-head">
              <div class="scd-ml-comparision__accordian-title">
                Comparision of Ranks
              </div>
              <div class="scd-ml-comparision__accordian-head-icons">
                <div class="scd-ml-comparision__accordian-icon">
                  <img
                    src="../../../../../assets/images/svg/download-icon.svg"
                    alt=""
                  />
                </div>
                <div (click)="autoMlService.isRank = !autoMlService.isRank" class="scd-ml-comparision__accordian-icon arrow">
                  <img
                    src="../../../../../assets/images/svg/arrow-down.svg"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div class="scd-ml-comparision__accordian-contents">
              <div class="scad-tab-log__table">
                <div class="table-wrapper">
                  <table>
                    <tbody>
                      <tr>
                        <th *ngFor="let item of getRankTableKey()">{{ item }}</th>
                      </tr>
                      <tr *ngFor="let item of autoMlService.rankCompareTableData; let i = index">
                        <td *ngFor="let key of getRankTableKey()">
                          <div class="data-cell">
                            <svg
                              *ngIf="item[key] === 'Success'"
                              xmlns="http://www.w3.org/2000/svg"
                              width="23"
                              height="23"
                              viewBox="0 0 23 23"
                              fill="none"
                            >
                              <path
                                d="M11.1752 19.2837C15.6534 19.2837 19.2837 15.6534 19.2837 11.1752C19.2837 6.69696 15.6534 3.06665 11.1752 3.06665C6.69696 3.06665 3.06665 6.69696 3.06665 11.1752C3.06665 15.6534 6.69696 19.2837 11.1752 19.2837Z"
                                fill="#659B5C"
                              />
                              <path
                                d="M6.89331 11.141L9.96818 14.2159L15.4574 8.13452"
                                stroke="white"
                                stroke-width="1.5"
                                stroke-miterlimit="10"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                            <svg
                              *ngIf="item[key] === 'Error'"
                              xmlns="http://www.w3.org/2000/svg"
                              width="23"
                              height="23"
                              viewBox="0 0 23 23"
                              fill="none"
                            >
                              <path
                                d="M20.125 11.5C20.125 6.73828 16.2617 2.875 11.5 2.875C6.73828 2.875 2.875 6.73828 2.875 11.5C2.875 16.2617 6.73828 20.125 11.5 20.125C16.2617 20.125 20.125 16.2617 20.125 11.5Z"
                                fill="#E65E6E"
                              />
                              <path
                                d="M11.2422 7.4593L11.5001 12.9375L11.7575 7.4593C11.7591 7.42428 11.7535 7.3893 11.7411 7.35651C11.7287 7.32371 11.7098 7.29378 11.6854 7.26856C11.6611 7.24333 11.6318 7.22333 11.5995 7.20979C11.5672 7.19624 11.5324 7.18943 11.4974 7.18977V7.18977C11.4627 7.1901 11.4285 7.1974 11.3968 7.21124C11.365 7.22509 11.3364 7.24519 11.3125 7.27034C11.2887 7.2955 11.2702 7.3252 11.2581 7.35766C11.2461 7.39013 11.2406 7.4247 11.2422 7.4593V7.4593Z"
                                stroke="white"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M11.5 16.5272C11.3223 16.5272 11.1486 16.4745 11.0009 16.3758C10.8531 16.2771 10.738 16.1368 10.67 15.9726C10.602 15.8084 10.5842 15.6278 10.6188 15.4535C10.6535 15.2792 10.7391 15.1191 10.8647 14.9935C10.9904 14.8678 11.1504 14.7823 11.3247 14.7476C11.499 14.7129 11.6796 14.7307 11.8438 14.7987C12.008 14.8667 12.1483 14.9819 12.247 15.1296C12.3457 15.2774 12.3984 15.4511 12.3984 15.6288C12.3984 15.8671 12.3038 16.0956 12.1353 16.2641C11.9668 16.4326 11.7383 16.5272 11.5 16.5272Z"
                                fill="white"
                              />
                            </svg>
                            {{ item[key] }}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!-- <div class="pagination">
                    <div class="row-count">
                      <p>Row per page</p>
                      <ng-select
                        [items]="pageArr"
                        [searchable]="false"
                        [clearable]="false"
                        [(ngModel)]="selectedPage"
                      ></ng-select>
                      <p>{{ "of " + _fb.previewData.length + " rows" }}</p>
                    </div>
                    <div class="row-pagination">
                      <svg
                        (click)="decriement()"
                        class="left"
                        xmlns="http://www.w3.org/2000/svg"
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                      >
                        <circle
                          cx="16"
                          cy="16"
                          r="16"
                          transform="matrix(-1 0 0 1 32 0)"
                          fill="#1847DF"
                        />
                        <path
                          d="M13 12.5L18 16.45L13 20.3571"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      <div class="number">{{ page }}</div>
                      <p>{{ "out of " + testData.length }}</p>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        (click)="incriement()"
                      >
                        <circle
                          cx="16"
                          cy="16"
                          r="16"
                          transform="matrix(-1 0 0 1 32 0)"
                          fill="#1847DF"
                        />
                        <path
                          d="M13 12.5L18 16.45L13 20.3571"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  </div> -->
              </div>
              <div class="scd-ml-comparision__accordian-chart-sec">
                <hr class="scd-ml-comparision__accordian-line" />
                <!-- <app-line-chart-html titlechart="Comparision of Ranks"  [barData]="autoMlService.rankTableData" [maxValue]="autoMlService.rankTableDataMaxvalue" [groups]="autoMlService.rankGroupData"></app-line-chart-html> -->
                
              </div>
             
            </div>
          </div>
          <div class="scd-ml-comparision__accordian" [ngClass]="{'active': !autoMlService.isScore}">
            <div class="scd-ml-comparision__accordian-head">
              <div class="scd-ml-comparision__accordian-title">
                Comparison of Importance Score
              </div>
              <div class="scd-ml-comparision__accordian-head-icons">
                <div class="scd-ml-comparision__accordian-icon">
                  <img
                    src="../../../../../assets/images/svg/download-icon.svg"
                    alt=""
                  />
                </div>
                <div (click)="autoMlService.isScore = !autoMlService.isScore" class="scd-ml-comparision__accordian-icon arrow">
                  <img
                    src="../../../../../assets/images/svg/arrow-down.svg"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div class="scd-ml-comparision__accordian-contents">
              <div class="scad-tab-log__table">
                <div class="table-wrapper">
                  <table>
                    <tbody>
                      <tr>
                        <th *ngFor="let item of getScoreTableKey()">{{ item }}</th>
                      </tr>
                      <tr *ngFor="let item of autoMlService.scoreCompareTableData; let i = index">
                        <td *ngFor="let key of getScoreTableKey()">
                          <div class="data-cell">
                            <svg
                              *ngIf="item[key] === 'Success'"
                              xmlns="http://www.w3.org/2000/svg"
                              width="23"
                              height="23"
                              viewBox="0 0 23 23"
                              fill="none"
                            >
                              <path
                                d="M11.1752 19.2837C15.6534 19.2837 19.2837 15.6534 19.2837 11.1752C19.2837 6.69696 15.6534 3.06665 11.1752 3.06665C6.69696 3.06665 3.06665 6.69696 3.06665 11.1752C3.06665 15.6534 6.69696 19.2837 11.1752 19.2837Z"
                                fill="#659B5C"
                              />
                              <path
                                d="M6.89331 11.141L9.96818 14.2159L15.4574 8.13452"
                                stroke="white"
                                stroke-width="1.5"
                                stroke-miterlimit="10"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                            <svg
                              *ngIf="item[key] === 'Error'"
                              xmlns="http://www.w3.org/2000/svg"
                              width="23"
                              height="23"
                              viewBox="0 0 23 23"
                              fill="none"
                            >
                              <path
                                d="M20.125 11.5C20.125 6.73828 16.2617 2.875 11.5 2.875C6.73828 2.875 2.875 6.73828 2.875 11.5C2.875 16.2617 6.73828 20.125 11.5 20.125C16.2617 20.125 20.125 16.2617 20.125 11.5Z"
                                fill="#E65E6E"
                              />
                              <path
                                d="M11.2422 7.4593L11.5001 12.9375L11.7575 7.4593C11.7591 7.42428 11.7535 7.3893 11.7411 7.35651C11.7287 7.32371 11.7098 7.29378 11.6854 7.26856C11.6611 7.24333 11.6318 7.22333 11.5995 7.20979C11.5672 7.19624 11.5324 7.18943 11.4974 7.18977V7.18977C11.4627 7.1901 11.4285 7.1974 11.3968 7.21124C11.365 7.22509 11.3364 7.24519 11.3125 7.27034C11.2887 7.2955 11.2702 7.3252 11.2581 7.35766C11.2461 7.39013 11.2406 7.4247 11.2422 7.4593V7.4593Z"
                                stroke="white"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M11.5 16.5272C11.3223 16.5272 11.1486 16.4745 11.0009 16.3758C10.8531 16.2771 10.738 16.1368 10.67 15.9726C10.602 15.8084 10.5842 15.6278 10.6188 15.4535C10.6535 15.2792 10.7391 15.1191 10.8647 14.9935C10.9904 14.8678 11.1504 14.7823 11.3247 14.7476C11.499 14.7129 11.6796 14.7307 11.8438 14.7987C12.008 14.8667 12.1483 14.9819 12.247 15.1296C12.3457 15.2774 12.3984 15.4511 12.3984 15.6288C12.3984 15.8671 12.3038 16.0956 12.1353 16.2641C11.9668 16.4326 11.7383 16.5272 11.5 16.5272Z"
                                fill="white"
                              />
                            </svg>
                            {{ item[key] }}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!-- <div class="pagination">
                    <div class="row-count">
                      <p>Row per page</p>
                      <ng-select
                        [items]="pageArr"
                        [searchable]="false"
                        [clearable]="false"
                        [(ngModel)]="selectedPage"
                      ></ng-select>
                      <p>{{ "of " + _fb.previewData.length + " rows" }}</p>
                    </div>
                    <div class="row-pagination">
                      <svg
                        (click)="decriement()"
                        class="left"
                        xmlns="http://www.w3.org/2000/svg"
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                      >
                        <circle
                          cx="16"
                          cy="16"
                          r="16"
                          transform="matrix(-1 0 0 1 32 0)"
                          fill="#1847DF"
                        />
                        <path
                          d="M13 12.5L18 16.45L13 20.3571"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      <div class="number">{{ page }}</div>
                      <p>{{ "out of " + testData.length }}</p>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        (click)="incriement()"
                      >
                        <circle
                          cx="16"
                          cy="16"
                          r="16"
                          transform="matrix(-1 0 0 1 32 0)"
                          fill="#1847DF"
                        />
                        <path
                          d="M13 12.5L18 16.45L13 20.3571"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  </div> -->
              </div>
              <div class="scd-ml-comparision__accordian-chart-sec">
                <hr class="scd-ml-comparision__accordian-line" />
                <!-- <app-line-chart-html titlechart="Comparison of Importance Score" [barData]="autoMlService.scoreTableData" [maxValue]="autoMlService.scoreTableDataMaxvalue" [groups]="autoMlService.scoreGroupData"></app-line-chart-html> -->
                
              </div>
             
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="typeOfIncome === 'Comparision'" class="scad-tab-log__right-sec">
      <div class="scd-ml-comparision__right-head">Select variables</div>
      <div class="scd-ml-comparision__variable-btn active">
        <span class="scd-ml-comparision__variable-tick"></span>
        variable 1
      </div>
      <div class="scd-ml-comparision__variable-btn">
        <span class="scd-ml-comparision__variable-tick"></span>
        variable 1
      </div>
    </div>
  </div>
  
  
  
  
</div>
<ng-template #nodata >
    <div class="no-data" >
        Run Iteration
    </div> 
</ng-template>
<svg
  class="toggle"
  xmlns="http://www.w3.org/2000/svg"
  width="53"
  height="21"
  viewBox="0 0 53 21"
  fill="none"
>
  <rect
    x="53"
    width="21"
    height="53"
    rx="10.5"
    transform="rotate(90 53 0)"
    fill="#9DA2AE"
  />
  <path
    d="M23.1001 12.4429L26.2337 16.4095L29.3334 12.4429"
    stroke="white"
    stroke-width="1.61905"
    stroke-miterlimit="10"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M29.3335 8.39502L26.1999 4.42835L23.1002 8.39502"
    stroke="white"
    stroke-width="1.61905"
    stroke-miterlimit="10"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
